const NetworkFormDisclaimer = () => (
  <aside className="disclaimer">
    <p>
      La Iglesia Comunidad Cristiana de Fe y Viento Fresco solo está refiriendo una base de datos de
      emprendedores, pero en ningún caso los está recomendando, ni se hace responsable de ninguna
      transacción comercial, laboral o civil entre los mismos.
    </p>
    <p>
      Oramos a Dios para que entre los emprendedores crezcan las buenas relaciones y obtengas
      bendiciones en todo, basados en Gálatas 6:10 “Así que, según tengamos oportunidad, hagamos
      bien a todos, y mayormente a los de la familia de la fe”.
    </p>
  </aside>
);

export default NetworkFormDisclaimer;
